<template>
    <div>
        <component-new-header
            title="View Bulk Promotion"
            :isLoading="loading"
            :hasSearch="false"
            :hasReload="false"
            :hasRadio="false"
            :hasCreate="false"
            :hasback="true"
            @back-press="$router.push('/bulkPromotion')"
        />
        <b-card>
            <b-row class="entity-criteria-top-row">
                <b-col md="6">
                    <b-row>
                        <b-col md="12">
                            <h5 class="text-primary">Select Entity</h5>
                        </b-col>
                        <b-col cols="12">
                            <eb-select
                                disabled
                                class="select-background-white"
                                id="text"
                                type="text"
                                label="text"
                                placeholder="Select Entity"
                                :options="entityOptions"
                                v-model="entity"
                                :selected="selectedEntity"
                            >
                            </eb-select>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6">
                    <b-row>
                        <b-col md="12">
                            <h5 class="text-primary">Criteria Selection</h5>
                        </b-col>
                        <b-col cols="12">
                            <ev-select
                                disabled
                                class="select-background-white"
                                id="text"
                                type="text"
                                label="text"
                                placeholder="Select Criteria"
                                :options="criteriaOptions"
                                v-model="selectedCriteriaOptions"
                                :selected="selectedCriteriaOptions"
                            >
                            </ev-select>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <template v-for="(option, index) in selectedCriteriaOptions">
            <!-- Date: Use 6-6 layout to match Select Entity / Criteria Selection -->
            <b-row
                v-if="option === 'Date'"
                :key="`date-${index}`"
                class="criteria-row date-criteria-row"
            >
                <b-col md="6" class="mb-2 mb-md-0">
                    <b-row class="align-items-center">
                        <b-col cols="12" sm="4" md="3" class="mb-2 mb-md-0">
                            <label class="criteria-label mb-0">{{ option }}</label>
                        </b-col>
                        <b-col cols="12" sm="8" md="9" class="mb-2 mb-md-0">
                            <eb-select
                                disabled
                                type="text"
                                label="text"
                                placeholder="Select Option"
                                :options="operatorOptions"
                                v-model="selectedOperator"
                                :selected="selectedOperator[index]"
                            >
                            </eb-select>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="6" class="mb-2 mb-md-0">
                    <b-row>
                        <b-col cols="12">
                            <div class="date-fields-wrapper d-flex align-items-center flex-nowrap">
                                <b-input
                                    disabled
                                    :id="`start-date-${index}`"
                                    type="date"
                                    v-model="inputData[index].value.startDate"
                                    class="form-control date-input date-input-start"
                                ></b-input>
                                <b-input
                                    disabled
                                    :id="`end-date-${index}`"
                                    type="date"
                                    v-model="inputData[index].value.endDate"
                                    class="form-control date-input date-input-end"
                                ></b-input>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <!-- Other criteria types: Original layout -->
            <b-row
                v-else
                :key="`default-${index}`"
                class="criteria-row"
            >
                <b-col cols="12" sm="12" md="2" class="mb-2 mb-md-0 criteria-label-col">
                    <label class="criteria-label">{{ option }}</label>
                </b-col>
                <b-col cols="12" sm="6" md="4" class="mb-2 mb-md-0 criteria-operator-col">
                    <eb-select
                        disabled
                        type="text"
                        label="text"
                        placeholder="Select Option"
                        :options="operatorOptions"
                        v-model="selectedOperator"
                        :selected="selectedOperator[index]"
                    >
                    </eb-select>
                </b-col>
                <b-col cols="12" sm="6" md="6" class="mb-2 mb-md-0 criteria-value-col">
                    <b-form-input
                        readonly
                        v-if="option !== 'Age' && option !== 'Order Amount'"
                        v-model="inputData[index].value"
                    >
                    </b-form-input>

  <!-- Age -->
  <div v-if="option === 'Age'" class="age-row-padding">
    <b-row class="align-items-center">

      <b-col cols="4">
        <p class="mb-0">{{ inputData[index].value.gte }}</p>
      </b-col>

      <b-col cols="4" class="text-center">
        <label>Select Age</label>
      </b-col>

      <b-col cols="4" class="text-right">
        <p class="mb-0">{{ inputData[index].value.lte }}</p>
      </b-col>

      <b-col cols="12">
        <b-form-input
          disabled
          type="range"
          min="0"
          :max="max"
          v-model="inputData[index].value"
        ></b-form-input>
      </b-col>

    </b-row>
  </div>

  <!-- Order Amount -->
  <div v-if="option === 'Order Amount'" class="order-amount-wrapper">
    <b-row class="order-amount-row flex-nowrap">
      <b-col cols="6" class="order-amount-col">
        <b-input
          disabled
          :id="`start-date${index}`"
          type="number"
          placeholder="Lower Amount"
          v-model="inputData[index].value.gte"
          class="form-control"
        ></b-input>
      </b-col>
      <b-col cols="6" class="order-amount-col">
        <b-input
          disabled
          :id="`end-date${index}`"
          type="number"
          placeholder="Higher Amount"
          v-model="inputData[index].value.lte"
          class="form-control"
        ></b-input>
      </b-col>
    </b-row>
  </div>

                </b-col>
            </b-row>
            </template>

            <!-- <b-row class="justify-content-md-center my-2">
          <b-button disabled variant="primary" class="w-25"
            >VIEW IMPACTED CUSTOMER</b-button
          >
        </b-row> -->
        </b-card>

        <b-row class="my-2 impacted-buttons-row align-items-center">
            <b-col cols="12" sm="6" md="6" class="mb-2 mb-sm-0 d-flex align-items-center">
                <span class="impacted-cust"
                    >Impacted Customer ({{ getDataCriteriaById.count || 0 }})
                </span>
            </b-col>
            <b-col cols="12" sm="6" md="6" class="mb-2 mb-sm-0 d-flex align-items-center justify-content-sm-end">
                <b-button
                    @click="downloadDetails"
                    variant="outline-primary"
                    class="download-btn-right w-100 w-sm-auto"
                >
                    <i class="fa fa-file-text-o mx-2" aria-hidden="true"></i
                    >Download
                </b-button>
            </b-col>
        </b-row>
        <b-card class="cardStyle promo-config-card">
            <h4 class="text-primary section-title">Promotional Configuration</h4>
            <b-row class="promo-config-row">
                <b-col cols="12" sm="12" md="6" class="mb-2 mb-md-0">
                    <eb-select
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        type="text"
                        label="text"
                        placeholder="Promotion Type"
                        :options="typeOfPromo"
                        v-model="promoType"
                        :selected="promoType"
                        @input="templateTypeList"
                    ></eb-select>
                </b-col>
                <b-col cols="12" sm="12" md="6" class="mb-2 mb-md-0">
                    <eb-select
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        type="text"
                        label="text"
                        placeholder="Notification Type"
                        :options="typeOfNotificationOption"
                        v-model="notificationOption"
                        :selected="notificationOption"
                        @input="templateTypeList"
                    ></eb-select>
                </b-col>
            </b-row>
            <b-row class="promo-config-row align-items-center">
                <b-col cols="12" sm="12" md="6" class="mb-2 mb-md-0">
                    <eb-select
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        type="text"
                        label="text"
                        placeholder="Choose Template"
                        :options="templateOptionList"
                        v-model="templateOption"
                        :selected="templateOption"
                        @input="previewSelectedTemplate"
                    >
                    </eb-select>
                </b-col>
                <b-col cols="12" sm="12" md="6" class="mb-2 mb-md-0">
                   <b-form-input
  :disabled="
    getDataCriteriaById.count == '' ||
    getDataCriteriaById.notificatonStatus == 'COMPLETED' ||
    getDataCriteriaById.status == 'PENDING'
  "
  type="number"
  :placeholder="PromotionAmount"
  v-model="promoAmount"
  class="promo-input"
></b-form-input>
                </b-col>
            </b-row>
            <b-row class="promo-config-row preview-template-row">
                <b-col cols="12">
                    <div
                        disabled
                        contentEditable="false"
                        placeholder="Preview Template"
                        class="previewTemplate"
                        v-html="showPreviewHere"
                    ></div>
                </b-col>
            </b-row>
            <b-row class="timestamp-row">
                <b-col cols="12" sm="12" md="6" class="mb-2 mb-md-0">
                    <b-form-input
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        placeholder="Description"
                        v-model="description"
                    ></b-form-input>
                </b-col>
                <b-col cols="12" sm="4" md="2" class="mb-2 mb-md-0">
                    <b-input
                        disabled
                        type="text"
                        label="label"
                        placeholder="Choose Effective Timestamp"
                    ></b-input>
                </b-col>
                <b-col cols="12" sm="4" md="2" class="mb-2 mb-md-0">
                    <b-input
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        id="time-stamp"
                        type="date"
                        v-model="timestampDate"
                    ></b-input>
                </b-col>
                <b-col cols="12" sm="4" md="2" class="mb-2 mb-md-0">
                    <b-input
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        id="time-stamp"
                        type="time"
                        v-model="timestampTime"
                    ></b-input>
                </b-col>
            </b-row>
            <b-row class="my-2">
                <b-col cols="12" md="6" class="mb-2 mb-md-0">
                    <h5 class="impactValueStyle">
                        Total Impacted value :
                        {{ this.promoAmount * getDataCriteriaById.count || 0 }}
                    </h5>
                </b-col>
            </b-row>
            <b-row class="justify-content-center">
                <b-col cols="12" md="auto" class="text-center">
                    <b-button
                        :hidden="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        @click="createBulkNotification"
                        variant="primary"
                        class="submit-btn-custom"
                        >SUBMIT</b-button
                    >
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import evSelect from "@/components/FormElements/Multiselect.vue";
import ebButton from "@/components/FormElements/Button";
import ComponentNewHeader from "@/components/componentNewHeader";

import { mapGetters } from "vuex";
export default {
    components: { ebSelect, evSelect, ebButton, ComponentNewHeader },
    data() {
        return {
            resourceId: "",
            promoAmount: "",
            promoType: "",
            entity: "",
            loading: false,
            previewScreen: "",
            description: "",
            myToggle: false,
            rangeValue: 18,
            max: 100,
            startDate: "",
            endDate: "",
            startEndDate: "",
            criteriaOptions: [],
            operatorOptions: [],
            criteria: [],
            entityOptions: [
                {
                    text: "Order",
                    value: "ORDER",
                },
                {
                    text: "Customer",
                    value: "CUSTOMER",
                },
            ],
            typeOfNotificationOption: [
                {
                    text: "Email",
                    value: "EMAIL",
                },
                {
                    text: "Inapp",
                    value: "FCM",
                },
                {
                    text: "Sms",
                    value: "SMS",
                },
                {
                    text: "Whatsapp",
                    value: "WHATSAPP",
                },
            ],
            notificationOption: "",
            templateOption: "",
            showPreviewHere: "",
            timestampDate: "",
            timestampTime: "",
        };
    },

    computed: {
        ...mapGetters({
            getPromoTemplateTypeList:
                "bulkNotification/GetPromoTemplateTypeList",
            getPreviewTemplate: "bulkNotification/GetPreviewTemplate",
            getDataCriteriaById: "bulkNotification/GetDataCriteriaById",
            getDataTemplateById: "bulkNotification/GetDataTemplateById",
            getPromoType: "partner/GetWalletData",
        }),
        PromotionAmount() {
            if (this.promoType) {
                return this.promoType.text + " " + "Amount";
            } else return "Amount";
        },
        typeOfPromo() {
            let walletPromoType = this.getPromoType
                .filter((type) => {
                    if (!type.isCurrency) {
                        return type;
                    }
                })
                .map((promo) => {
                    return {
                        text:
                            promo.name.charAt(0).toUpperCase() +
                            promo.name.slice(1),
                        value: promo.code,
                        resourceKey: promo.resourceID,
                    };
                });
            return walletPromoType;
        },
        templateOptionList() {
            const selectTemplate = this.getPromoTemplateTypeList.map(
                (template) => ({
                    text: template.concern,
                    value: template?._id || "",
                }),
            );
            return selectTemplate;
        },

        selectedEntity() {
            const choosenEntity =
                this.getDataCriteriaById?.collectionName?.toLowerCase();
            return (
                choosenEntity?.charAt(0)?.toUpperCase() +
                    choosenEntity?.slice(1) || ""
            );
        },

        selectedCriteriaOptions() {
            const selectedOptions = this.getDataCriteriaById?.filterBy?.map(
                (selectedOption) => {
                    let result = selectedOption.field.replace(
                        /([A-Z])/g,
                        " $1",
                    );
                    let textValue =
                        result.charAt(0).toUpperCase() + result.slice(1);
                    return textValue;
                },
            );
            return selectedOptions;
        },

        selectedOperator() {
            const selectedOptions = this.getDataCriteriaById?.filterBy?.map(
                (selectedOption) => {
                    let result = selectedOption.filter.replace(
                        /([A-Z])/g,
                        " $1",
                    );
                    let operatorText =
                        result.charAt(0).toUpperCase() + result.slice(1);
                    return operatorText;
                },
            );
            return selectedOptions;
        },

        inputData() {
            const inputEntered = this.getDataCriteriaById?.filterBy?.map(
                (criteriaData) => {
                    if (criteriaData.data.value) {
                        let enteredData = {
                            value: criteriaData.data.value,
                        };
                        return enteredData;
                    } else {
                        let enteredData = {
                            value: {
                                startDate: criteriaData.data.gte,
                                endDate: criteriaData.data.lte,
                            },
                        };
                        return enteredData;
                    }
                },
            );
            return inputEntered;
        },

        scheudleDateTime() {
            let scheduleDate =
                this.getDataTemplateById?.data?.scheduleDate?.split("T");
            if (scheduleDate) {
                return scheduleDate[0];
            }
        },
        scheudleTimeDate() {
            let scheduleTime =
                this.getDataTemplateById?.data?.scheduleDate?.split("T");
            let timeSchedule = scheduleTime[1]?.split(".");
            if (timeSchedule) {
                return timeSchedule[0];
            }
        },
    },

    methods: {
        downloadDetails() {
            if (this.getDataCriteriaById.status === "PENDING") {
                this.$swal({
                    title: "Info",
                    text: "Fetching Customer List. Please Wait...",
                    type: "info",
                });
            } else if (
                this.getDataCriteriaById.count &&
                this.getDataCriteriaById.count !== 0
            ) {
                window.location = this.getDataCriteriaById.url;
            } else {
                this.$swal({
                    title: "Error",
                    text: "Data Not Available.",
                    type: "error",
                });
            }
        },

        async templateTypeList() {
            this.templateOption = "";
            this.resourceId = this.promoType?.resourceKey || "";
            let payload = {
                service: this.notificationOption?.value || "",
                concern: this.promoType?.value || "",
            };
            if (payload.service && payload.concern) {
                await this.$store.dispatch(
                    "bulkNotification/fetchPromoTemplateTypeList",
                    payload,
                );
            }
        },

        async previewSelectedTemplate() {
            let payload = {
                templateId: this.templateOption.value,
            };
            await this.$store.dispatch(
                "bulkNotification/fetchTemplateToPreview",
                payload,
            );
            this.showPreviewHere = this.showPreview()
                .map((pre) => pre.body)
                .join("")
                .toString();
        },

        showPreview() {
            const previewTemplate = this.getPreviewTemplate.map((preview) => ({
                body: preview?.body || "",
            }));
            return previewTemplate;
        },

        async createBulkNotification() {
            if (this.getDataCriteriaById.count !== 0) {
                if (
                    this.notificationOption.value &&
                    this.templateOption.value &&
                    this.promoAmount
                ) {
                    let payload = {
                        criteria: {
                            filterBy: this.getDataCriteriaById.filterBy,
                            retriveParams:
                                this.getDataCriteriaById.retriveParams,
                            status: this.getDataCriteriaById.status,
                            collectionName:
                                this.getDataCriteriaById.collectionName,
                            serviceUrl: this.getDataCriteriaById.serviceUrl,
                            tenant: this.getDataCriteriaById.tenant,
                            count: this.getDataCriteriaById.count,
                            url: this.getDataCriteriaById.url,
                            _id: this.getDataCriteriaById._id,
                        },
                        notificationType: this.notificationOption.value,
                        template: {
                            _id: this.getPreviewTemplate[0]._id,
                            name: this.getPreviewTemplate[0].service,
                            concern: this.getPreviewTemplate[0].concern,
                            body: this.getPreviewTemplate[0].body,
                            promotionType: this.promoType?.value,
                            amount: this.promoAmount,
                            type: "promo",
                            key: this.resourceId,
                            description: this.description,
                        },
                        description: this.description,
                        scheduleDate: this.timestampDate,
                        category: "PROMO",
                    };
                    await this.$store
                        .dispatch(
                            "bulkNotification/createBulkNotification",
                            payload,
                        )
                        .then((result) => {
                            this.$swal({
                                title: "Successful",
                                text: "Bulk Promotion Created Successfully!",
                                type: "success",
                            });
                            this.$router.push("/bulkPromotion");
                        })
                        .catch((err) => {
                            this.$swal({
                                title: "Sorry",
                                text: "Unable to Create Bulk Promotion!",
                                type: "error",
                            });
                        });
                } else {
                    this.$swal({
                        title: "Error",
                        text: "Select All Fields",
                        type: "error",
                    });
                }
            } else {
                this.$swal({
                    title: "Error",
                    text: "No Impacted Customer Available",
                    type: "error",
                });
            }
        },
    },

    async mounted() {
        this.loading = true;
        let payload1 = { id: this.$route.params.id };
        await this.$store.dispatch(
            "bulkNotification/fetchDetailsCriteriaById",
            payload1,
        );
        await this.$store.dispatch(
            "bulkNotification/fetchDetailsTemplateById",
            payload1,
        );
        let payload = { label: this.getDataCriteriaById.collectionName };
        await this.$store.dispatch("bulkNotification/fetchEntities", payload);
        if (this.getDataCriteriaById.status === "PENDING") {
            this.$swal({
                title: "Info",
                text: "Fetching Customer List. Please Wait...",
                type: "info",
            });
        }
        await this.$store.dispatch("partner/fetchWalletList");

        this.promoType =
            this.getDataTemplateById?.data?.template?.promotionType;
        this.notificationOption = this.typeOfNotificationOption.filter(
            (option) => {
                if (
                    option.value ==
                    this.getDataTemplateById?.data?.template?.name
                ) {
                    return option;
                }
            },
        );
        this.templateTypeList();
        this.templateOption = this.templateOptionList.filter((option) => {
            if (
                option.text == this.getDataTemplateById?.data?.template?.concern
            ) {
                return option;
            }
        });
        this.promoAmount = this.getDataTemplateById?.data?.template?.amount;
        this.showPreviewHere = this.getDataTemplateById?.data?.template?.body;
        this.description = this.getDataTemplateById?.data?.description;
        this.timestampDate = this.scheudleDateTime;
        this.loading = false;
    },
};
</script>
<style scoped>
.previewTemplate {
    margin: 0;
    height: 150px;
    padding: 12px;
    border: 1px solid rgb(228, 214, 214);
    border-radius: 4px;
    width: 100%;
    overflow: auto;
}

.previewTemplate[contentEditable="false"]:empty:before {
    content: attr(placeholder);
}

.form-control {
    height: calc(2.2125rem + 8px);
}
.impactValueStyle {
    color: #33a02c;
}
.form-control:disabled,
.form-control[readonly] {
    background-color: #f8f8f8;
    opacity: 1;
}
.impacted-cust {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    min-height: 40px;
    width: 100%;
    background-color: var(--secondary);
    color: #fff;
    border-radius: 0.25rem;
    padding: 0.375rem 0.75rem;
    font-weight: 500;
    box-sizing: border-box;
}

.select-background-white {
    background-color: #fff;
}

.criteria-operator-col >>> .vs__dropdown-toggle {
    height: calc(2.2125rem + 8px) !important;
    min-height: 38px !important;
}

.date-criteria-row {
    align-items: center;
}

.date-criteria-row >>> .form-group {
    margin-bottom: 0 !important;
}

.date-fields-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: -4px;
}

.date-fields-wrapper .date-input {
    height: calc(2.2125rem + 8px);
    min-height: 38px;
    flex: 1;
    min-width: 0;
}

.date-fields-wrapper .date-input-start {
    margin-right: 0.5rem;
}

@media (max-width: 575.98px) {
    .date-fields-wrapper {
        flex-direction: column;
        align-items: stretch;
    }

    .date-fields-wrapper .date-input-start {
        margin-right: 0;
        margin-bottom: 1.75rem;
    }
}

.age-row-padding {
    padding: 0px 20px;
}

.age-col-no-padding {
    padding: 0px;
}

.age-col-padding {
    padding: 0px 20px;
}

.age-value-right {
    text-align: right;
}

.criteria-row {
    align-items: flex-start;
    margin-bottom: 1rem;
}

.criteria-label {
    font-weight: 600;
    word-break: break-word;
}

.impacted-buttons-row {
    align-items: stretch;
    
}

.impacted-buttons-row .btn {
    height: 40px;
    min-height: 40px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
}

.download-btn-right {
    float: right;
}

.promo-config-row {
    align-items: flex-end;
    margin-bottom: 1.5rem;
}

.promo-config-row:last-of-type {
    margin-bottom: 1.5rem;
}

.promo-config-row >>> .form-group {
    margin-bottom: 0 !important;
}

.promo-input {
    height: calc(2.2125rem + 8px);
    min-height: 38px;
}

.promo-config-row ::v-deep .v-select .vs__dropdown-toggle,
.promo-config-row ::v-deep .vs__dropdown-toggle {
    height: calc(2.2125rem + 8px) !important;
    min-height: 38px !important;
}

.timestamp-row {
    align-items: flex-end;
}

.cardStyle {
    border-radius: 16px;
}

.promo-config-card {
    margin-top: 0.5rem;
}

.submit-btn-custom {
    min-width: 120px;
}

.section-title {
    margin-bottom: 2rem;
}

.section-subtitle {
    margin-bottom: 0.75rem;
}

.entity-criteria-top-row {
    margin-bottom: 1rem;
}

.entity-criteria-row {
    align-items: flex-start;
}

.order-amount-wrapper .order-amount-row {
    margin-top: -4px;
    align-items: flex-start;
}

.order-amount-wrapper .order-amount-col {
    flex: 1 1 0;
    min-width: 0;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
}

.order-amount-wrapper .order-amount-col:first-child {
    padding-left: 0;
    padding-right: 0.25rem;
}

.order-amount-wrapper .order-amount-col:last-child {
    padding-left: 0.25rem;
    padding-right: 0;
}

@media (max-width: 767.98px) {
    .download-btn-right {
        float: none;
        width: 100%;
    }

    .age-row-padding {
        padding: 0px 10px;
    }

    .age-col-padding {
        padding: 0px 10px;
    }

    .age-value-right {
        text-align: left;
    }

    .criteria-label {
        font-size: 0.9rem;
    }

    .previewTemplate {
        margin: 0;
        width: 100%;
        font-size: 0.875rem;
    }

    .impactValueStyle {
        font-size: 0.95rem;
    }

    .section-title {
        font-size: 1rem;
        margin-bottom: 2rem !important;
    }

    .section-subtitle {
        font-size: 0.95rem;
    }

    .promo-config-row {
        margin-bottom: 2rem !important;
    }

    .promo-config-card .promo-config-row [class*="col-"] {
        margin-bottom: 1rem !important;
    }

    .promo-config-card .timestamp-row [class*="col-"] {
        margin-bottom: 1rem !important;
    }

    .impacted-buttons-row {
        gap: 1rem;
    }
}

@media (max-width: 575.98px) {
    .previewTemplate {
        font-size: 0.8rem;
        height: 120px;
    }

    .criteria-label {
        font-size: 0.85rem;
    }
}
.promo-config-row .promo-input {
  height: calc(2.2125rem + 8px) !important;
  min-height: 38px !important;
}

.promo-config-row ::v-deep .vs__dropdown-toggle {
  height: calc(2.2125rem + 8px) !important;
  min-height: 38px !important;
}

.margin-left_8{
    margin-left:8% !important;
}
.promo-input {
  width: 100%;
}
</style>
